/* eslint-disable new-cap */
/* eslint-disable no-undef */

import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from '../SoundAssetKeys';

const box2d = { setup: null,
  update: null,
  createMarble: null,
  removeMarble: null,
  pauseResume: null };

export function setupBox2d() {
  // Box2d vars
  const b2Vec2 = Box2D.Common.Math.b2Vec2;
  const b2BodyDef = Box2D.Dynamics.b2BodyDef;
  const b2Body = Box2D.Dynamics.b2Body;
  const b2FixtureDef = Box2D.Dynamics.b2FixtureDef;
  const b2Fixture = Box2D.Dynamics.b2Fixture;
  const b2World = Box2D.Dynamics.b2World;
  const b2PolygonShape = Box2D.Collision.Shapes.b2PolygonShape;
  const b2CircleShape = Box2D.Collision.Shapes.b2CircleShape;
  const b2DebugDraw = Box2D.Dynamics.b2DebugDraw;
  const b2ContactListener = Box2D.Dynamics.b2ContactListener;

  let lastCollisionTime;

  // important box2d scale and speed vars
  const SCALE = 30; const STEP = 20; let TIMESTEP = 1 / STEP;

  let world;
  let lastTimestamp = Date.now();
  let fixedTimestepAccumulator = 0;
  let bodiesToRemove = [];
  const actors = [];
  const bodies = [];

  // box2d world setup and boundaries
  const setup = function() {
    world = new b2World(new b2Vec2(0,10), true);
    world.SetContactListener(contactListener);

    /** * Left Container *** */
    let floorFixture = new b2FixtureDef;
    floorFixture.density = 1;
    floorFixture.restitution = 0.2;
    floorFixture.shape = new b2PolygonShape;
    floorFixture.shape.SetAsBox((300 / SCALE) / 2, (5 / SCALE) / 2);
    let floorBodyDef = new b2BodyDef;
    floorBodyDef.type = b2Body.b2_staticBody;
    floorBodyDef.position.x = 150 / SCALE;
    floorBodyDef.position.y = 260 / SCALE;
    let floor = world.CreateBody(floorBodyDef);
    floor.CreateFixture(floorFixture);

    // boundaries - left
    let leftFixture = new b2FixtureDef;
    leftFixture.shape = new b2PolygonShape;
    leftFixture.shape.SetAsBox((1 / SCALE) / 2, (260 / SCALE) / 2);
    let leftBodyDef = new b2BodyDef;
    leftBodyDef.type = b2Body.b2_staticBody;
    leftBodyDef.position.x = 2 / SCALE;
    leftBodyDef.position.y = 110 / SCALE;
    let left = world.CreateBody(leftBodyDef);
    left.CreateFixture(leftFixture);

    // boundaries - right
    let rightFixture = new b2FixtureDef;
    rightFixture.shape = new b2PolygonShape;
    rightFixture.shape.SetAsBox(1 / SCALE, 260 / SCALE);
    let rightBodyDef = new b2BodyDef;
    rightBodyDef.type = b2Body.b2_staticBody;
    rightBodyDef.position.x = 310 / SCALE;
    rightBodyDef.position.y = 2 / SCALE;
    let right = world.CreateBody(rightBodyDef);
    right.CreateFixture(rightFixture);


    /** ** RIGHT CONTAINER **** */
    floorFixture = new b2FixtureDef;
    floorFixture.density = 1;
    floorFixture.restitution = 0.2;
    floorFixture.shape = new b2PolygonShape;
    floorFixture.shape.SetAsBox((300 / SCALE) / 2, (5 / SCALE) / 2);
    floorBodyDef = new b2BodyDef;
    floorBodyDef.type = b2Body.b2_staticBody;
    floorBodyDef.position.x = 470 / SCALE;
    floorBodyDef.position.y = 260 / SCALE;
    floor = world.CreateBody(floorBodyDef);
    floor.CreateFixture(floorFixture);

    // boundaries - left
    leftFixture = new b2FixtureDef;
    leftFixture.shape = new b2PolygonShape;
    leftFixture.shape.SetAsBox(1 / SCALE, 260 / SCALE);
    leftBodyDef = new b2BodyDef;
    leftBodyDef.type = b2Body.b2_staticBody;
    leftBodyDef.position.x = 326 / SCALE;
    leftBodyDef.position.y = 100 / SCALE;
    left = world.CreateBody(leftBodyDef);
    left.CreateFixture(leftFixture);

    // boundaries - right
    rightFixture = new b2FixtureDef;
    rightFixture.shape = new b2PolygonShape;
    rightFixture.shape.SetAsBox(1 / SCALE, 260 / SCALE);
    rightBodyDef = new b2BodyDef;
    rightBodyDef.type = b2Body.b2_staticBody;
    rightBodyDef.position.x = 630 / SCALE;
    rightBodyDef.position.y = 100 / SCALE;
    right = world.CreateBody(rightBodyDef);
    right.CreateFixture(rightFixture);
  };

  // actor object - this is responsible for taking the body's position and translating it to your easel display object
  const actorObject = function(body, skin) {
    this.body = body;
    this.skin = skin;
    this.update = function() {  // translate box2d positions to pixels
      this.skin.angle = this.body.GetAngle() * (180 / Math.PI);
      this.skin.x = this.body.GetWorldCenter().x * SCALE;
      this.skin.y = this.body.GetWorldCenter().y * SCALE;
    };
    actors.push(this);
  };

  // remove actor and it's skin object
  const removeActor = function(actor) {
    actors.splice(actors.indexOf(actor),1);
  };

  // box2d update function. delta time is used to avoid differences in simulation if frame rate drops
  const update = function() {
    const now = Date.now();
    const dt = now - lastTimestamp;
    fixedTimestepAccumulator += dt;
    lastTimestamp = now;
    while (fixedTimestepAccumulator >= STEP) {
      // remove bodies before world timestep
      for (let i = 0, l = bodiesToRemove.length; i < l; i++) {
        removeActor(bodiesToRemove[i].GetUserData());
        bodiesToRemove[i].SetUserData(null);
        world.DestroyBody(bodiesToRemove[i]);
      }
      bodiesToRemove = [];

      // update active actors
      for (let i = 0, l = actors.length; i < l; i++) {
        actors[i].update();
      }

      world.Step(TIMESTEP, 10, 10);

      fixedTimestepAccumulator -= STEP;
      world.ClearForces();
      if (world.m_debugDraw) world.m_debugDraw.m_sprite.graphics.clear();
      world.DrawDebugData();
    }
  };

  const pauseResume = function(p) {
    if (p) {
      TIMESTEP = 0;
    }
    else { TIMESTEP = 1 / STEP; }
    lastTimestamp = Date.now();
  };

  // body shape and actor object
  const createMarble = function(skin) {
    const marbleFixture = new b2FixtureDef;
    marbleFixture.density = 1;
    marbleFixture.restitution = .2;
    marbleFixture.shape = new b2CircleShape(25 / SCALE);

    const marbleBodyDef = new b2BodyDef;
    marbleBodyDef.type = b2Body.b2_dynamicBody;
    marbleBodyDef.position.x = skin.x / SCALE;
    marbleBodyDef.position.y = skin.y / SCALE;
    const marble = world.CreateBody(marbleBodyDef);
    marble.CreateFixture(marbleFixture);
    marble.destroy = () => {}; // Phaser requires a destroy function on bodies... this prevents an error

    // assign actor
    const actor = new actorObject(marble, skin);
    marble.SetUserData(actor);  // set the actor as user data of the body so we can use it later: body.GetUserData()
    bodies.push(marble);
    return marble;
  };

  const removeMarble = function(body) {
    const index = bodies.indexOf(body);
    removeActor(body.GetUserData());
    body.SetUserData(null);
    world.DestroyBody(body);
    bodies.splice(index,1);
  };

  const contactListener = new b2ContactListener();
  contactListener.BeginContact = function(contact) {
    const test1 = contact.GetFixtureA().GetBody();
    const test2 = contact.GetFixtureB().GetBody();
    if (test1.m_userData && test2.m_userData) {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._MarbleSound, test1.m_userData.skin.scene);
    }
  };
  box2d.setup = setup;
  box2d.update = update;
  box2d.createMarble = createMarble;
  box2d.removeMarble = removeMarble;
  box2d.pauseResume = pauseResume;
}

export default box2d;